import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncLocalSearch = Load(
  () =>
    import(
      /* webpackChunkName: "local-search" */ './containers/LocalSearchContainer'
    ),
  {},
  true,
);

const AsyncLocalSearchPage = Load(
  () =>
    import(
      /* webpackChunkName: "local-search-page" */ './containers/LocalSearchPageContainer'
    ),
  {},
  true,
);

const LocalGuideRoutes = [
  <NavigationableLayout
    key="local-search"
    path={`${basePath}/locals`}
    component={AsyncLocalSearch}
    showBottomNavigation
    showSearchInNavbar
  />,
  <NavigationableLayout
    key="local-search-page"
    path={`${basePath}/l`}
    component={AsyncLocalSearchPage}
    showBottomNavigation
    showFullSearchInNavbar
    showSearchInNavbar
  />,
];

export default LocalGuideRoutes;
